import _ from "underscore";

import React from 'react';
import createReactClass from 'create-react-class';
import BaseMixin from './BaseMixin';
import Styles from './../StyleSheet';

const PhoneType = createReactClass({
  displayName: 'PhoneType',
  mixins: [BaseMixin],

  render: function() {
    return (
      <form className="form-inline">
        {this.renderTerminalName()}
        <select
          className="form-control"
          style={this._selectStyles()}
          value={this.props.node.get('terminal')}
          onChange={this._onTypeChange}
          disabled={!this.props.editable}
        >
          <option value="mobile">Mobile</option>
          <option value="landline">Landline</option>
        </select>
      </form>
    );
  },

  _onTypeChange: function(evt) {
    this.props.node.set('terminal', evt.target.value);
  },

  _selectStyles: function() {
    return (
      _.extend(
        {},
        Styles.select,
        Styles.lastChild
      )
    );
  }
});

export default PhoneType;
